import React, {Component} from "react";
import {
    Button,
    FormSection,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import {Form} from "react-bootstrap";
import InputGroup from "../../node_modules/react-bootstrap/InputGroup";

import DatePicker from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import prefactures from "../Constants/Prefectures";
import * as PropTypes from "prop-types";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import BlockUi from 'react-block-ui';
import '../../node_modules/react-block-ui/style.css';
import '../Styles/genelife.css';
import '../Styles/subpages.css';
import bloodtypes from "../Constants/BloodTypes";

export class SignUpComponents extends Component {

  constructor(props) {
      super(props);
      this.state = {
        hidden: true,
        signUpMoved: false
      };
      this.toggleShow = this.toggleShow.bind(this);
    }

    handlePasswordChange(e) {
      this.setState({ password: e.target.value });
    }

    toggleShow() {
      this.setState({ hidden: !this.state.hidden });
    }

    componentDidMount() {
      if (this.props.password) {
        this.setState({ password: this.props.password });
      }
    }

    componentDidUpdate(prevProps) {
        if (this.elementRef && !this.state.signUpMoved && this.props.action_type === 'connected_oauth') {
            window.scrollTo(0, this.elementRef.getBoundingClientRect().y);
            this.setState({ signUpMoved: true });
        } else if (this.elementRefSignUpFlowTop && !this.state.signUpMoved && this.props.action_type === 'connected_social_provider') {
            window.scrollTo(0, this.elementRefSignUpFlowTop.getBoundingClientRect().y);
            this.setState({ signUpMoved: true });
        }
    }

    render() {
        return (
        <div>
        <Header/>

          <div className="content_wrapper" >
            <h2 className="title_content" theme={this.props.theme}>{I18n.get("coustome sign up")}</h2>
              <div className="backto">
                  <Link theme={this.props.theme} onClick={this.props.changeStateFunc}>
                      {I18n.get("Back to Sign In")}
                  </Link>
              </div>
            {
                (() => {
                    if (this.props.mode === "wgs") {
                        return(
                            <div>
                                <div className="container">
                                    <img src={require("../images/wgs/wgs_logo.png")} alt="wgs" width="215" />
                                    <div className="wgshead_line"></div>
                                    <h2 className="wgs_headtitle">ご利用ガイド</h2>
                                </div>
                                <div className="covidmainfield">
                                    <div className="contentwrap">
                                        <div className="fieldwrap">

                                            <h2 className="fieldtitle">検査の流れ</h2>
                                            <ol class="flow-regist -singleline">
                                                <li className="active">
                                                    <h3>アカウント新規登録</h3>
                                                </li>
                                                <li className="">
                                                    <h3>検査申込同意・検査ID登録</h3>
                                                </li>
                                                <li className="">
                                                    <h3>検査試料の採取・返送</h3>
                                                </li>
                                            </ol>
                                        </div>
                                        <div className="fieldwrap">
                                            <h2 className="fieldtitle">新規アカウント登録</h2>
                                            <div className="coutionbox">
                                                必ず検査を受ける方の情報を入力してください。
                                            </div>
                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    } else {
                        return(
                            <div className="container">
                                    <div className="main_login_boxhead" ref={ element => { this.elementRefSignUpFlowTop = element }}><h3>通常の新規登録の場合はこちら​</h3></div>
                          {(() => {
                              if (!this.props.action_type || this.props.action_type === 'unconnected_oauth'|| this.props.action_type === 'connected_social_provider') {
                                  return(
                                      <div className="new_flow">
                                          <h3 className="new_flow_title">新規登録の流れ</h3>
                                          <div className="slide">
                                          <div className="row">
                                              <div className="col-3">
                                                  <img src={require("../images/login/flow01.svg")} alt="登録情報の入力"/>
                                                  <div className="bg-w">必須項目をすべてご入力ください。</div>
                                              </div>
                                              <div className="col-3">
                                                  <img src={require("../images/login/flow02.svg")} alt="認証コードの確認"/>
                                                  <div className="bg-w">登録したメールアドレス宛に届いた認証コードをご確認ください。</div>
                                              </div>
                                              <div className="col-3">
                                                  <img src={require("../images/login/flow03.svg")} alt="認証"/>
                                                  <div className="bg-w">認証コードをご入力ください。</div>
                                              </div>
                                              <div className="col-3">
                                                  <img src={require("../images/login/flow04.svg")} alt="新規登録完了"/>
                                                  <div className="bg-w">認証コードが承認後、新規登録完了。ログイン画面からログインできます。</div>
                                              </div>
                                          </div>
                                          </div>
                                      </div>
                                   )
                              }
                          })()}




                          <p className="text-center attention_blue">必ず遺伝子を採取する方の情報を入力してください。</p>
                          <p className="text-center"><span className="requre">※</span>検査申込者にご記入いただく検査申込同意書に記載の情報と異なる場合、検査結果が反映されません。
                          </p>
                                </div>
                        );
                      }
                })()
            }

              <BlockUi tag="div" blocking={this.props.blocking} message="登録中です。少々お待ちください。" keepInView={this.props.keepInView}>
                  <div className="area_usual">
                      <div className="container">
       
                          <div className="form_content" ref={ element => { this.elementRef = element }}>
                              <FormSection theme={this.props.theme}>
                                  <SectionBody theme={this.props.theme}>
                                      <p className="tspace"><span className="requre">※</span>は必須項目です。<span className="text-danger text-bold">本人確認に使用する場合がありますので正確にご入力ください</span></p>
                                      <Form>
                                          {(() => {
                                              if (this.props.action_type === 'unconnected_oauth') {
                                                  return ([<Form.Group key={1} controlId="formGroupMail">
                                                      <Form.Label>メールアドレス<span className="requre">※</span></Form.Label>
                                                      <Form.Control type="email" placeholder="(例)aaa@bb.jpl"
                                                                    name="email"
                                                                    value={this.props.email}
                                                                    onChange={this.props.handleInputChangeSignUp}
                                                                    onBlur={this.props.handleOnBlur}
                                                      />
                                                      {this.props.email_err_msg}
                                                      <Form.Text className="text-muted">
                                                          確認のため再入力してください。
                                                      </Form.Text>
                                                      <Form.Control type="email" placeholder="(例)aaa@bb.jpl"
                                                                    name="email_confirm"
                                                                    value={this.props.emailConfirm}
                                                                    onBlur={this.props.handleOnBlur}
                                                                    onChange={this.props.handleInputChangeSignUp}
                                                                    bsPrefix={"form-control"}
                                                      />
                                                      {this.props.email_confirm_err_msg}
                                                      <div
                                                          className="sub_attention">※携帯電話メールアドレス宛に返信をご希望の場合は、迷惑メール対策(ドメイン指定受信・指定受信機能など)の設定で
                                                          「@genelife.jp」ドメインからのメールが受信できるように設定くださいますようお願いいたします。 <br/>
                                                          ※携帯電話メールアドレスをご登録される場合、重要なお知らせが届かない場合がございますので、
                                                          パソコンもしくはスマートフォンのメールアドレスのご登録を推奨いたします。
                                                      </div>
                                                  </Form.Group>])
                                              } else {
                                                  return ([<Form.Group key={1} controlId="formGroupMail">
                                                      <Form.Label>メールアドレス</Form.Label>
                                                      <Form.Control type="email" placeholder="(例)aaa@bb.jpl"
                                                                    name="email" disabled
                                                                    value={this.props.email}
                                                                    onBlur={this.props.handleOnBlur}
                                                                    onChange={this.props.handleInputChangeSignUp}
                                                      />
                                                  </Form.Group>])

                                              }
                                          })()}
                                          <Form.Group controlId="formGroupPassword" key={2}>
                                              <Form.Label>パスワード<span className="requre">※</span></Form.Label>
                                              <p>※パスワードは 半角で8文字以上（大文字英字A~Z、小文字英字a~z、数字0~9をそれぞれ最低 1文字以上をご使用ください）</p>
                                              <Form.Control
                                                  type={this.state.hidden ? "password" : "text"}
                                                  placeholder="Gene0210"
                                                  name="password"
                                                  value={this.props.password}
                                                  onBlur={this.props.handleOnBlur}
                                                  onChange={this.props.handleInputChangeSignUp}
                                              />
                                              {this.props.password_err_msg}
                                              <div><label><input type="checkbox" onClick={this.toggleShow} />パスワードを表示する </label></div>
                                              <Form.Text className="text-muted">
                                                  パスワード入力ミス防止のため、もう一度入力してください。
                                              </Form.Text>
                                              <Form.Control type="password" placeholder="確認用パスワード"
                                                            name="password_confirm"
                                                            value={this.props.passwordConfirm}
                                                            onBlur={this.props.handleOnBlur}
                                                            onChange={this.props.handleInputChangeSignUp}
                                              />
                                              {this.props.password_confirm_err_msg}
                                          </Form.Group>

                                          <Form.Group controlId="formGroupName">
                                              <Form.Label>お名前<span className="requre">※</span></Form.Label>
                                              <InputGroup className="mb-4">
                                                  <Form.Control placeholder="姓:(例)山田"
                                                                name="name01"
                                                                value={this.props.name01}
                                                                onChange={this.props.handleInputChangeSignUp}
                                                  />
                                                  <Form.Control placeholder="名:(例)太郎"
                                                                name="name02"
                                                                value={this.props.name02}
                                                                onChange={this.props.handleInputChangeSignUp}
                                                  />
                                              </InputGroup>
                                              {this.props.name01_err_msg}
                                              {this.props.name02_err_msg}
                                          </Form.Group>
                                          <Form.Group controlId="formGroupKatakana">
                                              <Form.Label>フリガナ<span className="requre">※</span></Form.Label>
                                              <InputGroup className="mb-4">
                                                  <Form.Control placeholder="姓:(例)ヤマダ"
                                                                name="kana01"
                                                                value={this.props.kana01}
                                                                onChange={this.props.handleInputChangeSignUp}
                                                  />
                                                  <Form.Control placeholder="名:(例)タロウ"
                                                                name="kana02"
                                                                value={this.props.kana02}
                                                                onChange={this.props.handleInputChangeSignUp}
                                                  />
                                              </InputGroup>
                                              {this.props.kana01_err_msg}
                                              {this.props.kana02_err_msg}
                                              {this.props.kana_err_msg}
                                          </Form.Group>
                                          <Form.Group controlId="formGroupKatakana">
                                              <Form.Label>ニックネーム<span className="requre">※</span></Form.Label>
                                              <Form.Control
                                                  name="name03"
                                                  value={this.props.name03}
                                                  onChange={this.props.handleInputChangeSignUp}
                                              />
                                              {this.props.name03_err_msg}
                                          </Form.Group>

                                          <Form.Group className="mb-3">
                                              <Form.Label>生年月日<span className="requre">※</span></Form.Label>
                                              <div>
                                                  <DatePicker
                                                      locale={ja}
                                                      dateFormat="yyyy/MM/dd"
                                                      name="birth"
                                                      showYearDropdown
                                                      showMonthDropdown
                                                      maxDate={new Date()}
                                                      selected={this.props.birth}
                                                      onChange={this.props.handleBirthChange}
                                                      dropdownMode="select"/>
                                              </div>
                                              {this.props.birth_err_msg}
                                          </Form.Group>

                                          <Form.Group className="mb-3">
                                              <Form.Label>性別<span className="requre">※</span></Form.Label>
                                              <div key={`inline-radio`} className="mb-3">
                                                  <Form.Check inline label="男" type="radio" id={`inline-radio-1`}
                                                              name="men"
                                                              value="1"
                                                              checked={this.props.menChecked}
                                                              onChange={this.props.handleRadioClick}
                                                  />
                                                  <Form.Check inline label="女" type="radio" id={`inline-radio-2`}
                                                              name="women"
                                                              value="2"
                                                              checked={this.props.womenChecked}
                                                              onChange={this.props.handleRadioClick}
                                                  />
                                              </div>
                                          </Form.Group>

                                          <Form.Group className="mb-3">
                                            <Form.Label>血液型<span className="requre">※</span></Form.Label>
                                              <Form.Control as="select" value={this.props.bloodtype}
                                                            onChange={this.props.handleInputChangeSignUp} name="bloodtype">
                                                  {bloodtypes.map(bloodtype =>
                                                      <option key={bloodtype.value} value={bloodtype.value}>
                                                          {bloodtype.name}
                                                      </option>
                                                  )}
                                              </Form.Control>
                                              {this.props.bloodtype_err_msg}
                                          </Form.Group>

                                          <Form.Group className="mb-3">
                                              <Form.Label>メルマガ配信<span className="requre">※</span></Form.Label>
                                              <div key={`inline-radio`} className="mb-3">
                                                  <Form.Check inline label="希望する" type="radio" id={`inline-radio-3`}
                                                              name="mailmaga_demand"
                                                              value="2"
                                                              checked={this.props.mailmagaDemandChecked}
                                                              onChange={this.props.handleRadioMailMagaClick}
                                                  />
                                                <Form.Check inline label="希望しない" type="radio" id={`inline-radio-4`}
                                                              name="mailmaga_undemand"
                                                              value="3"
                                                              checked={this.props.mailmagaUndemandChecked}
                                                              onChange={this.props.handleRadioMailMagaClick}
                                                  />
                                              </div>
                                          </Form.Group>

                                          <Form.Group controlId="formGridZip">
                                              <Form.Label>郵便番号<span className="requre">※</span> </Form.Label>
                                              <Form.Control placeholder="(例)150-6026"
                                                            name="zip"
                                                            onChange={this.props.handleZipChange}
                                                            onBlur={this.props.handleOnBlur}
                                                            value={this.props.zip}
                                              />
                                              {this.props.zip_err_msg}
                                          </Form.Group>


                                          <Form.Group controlId="formGridPrefecture">
                                              <Form.Label>都道府県<span className="requre">※</span></Form.Label>
                                              <Form.Control as="select" value={this.props.pref}
                                                            onChange={this.props.handleInputChangeSignUp} name="pref">
                                                  {prefactures.map(this.props.callbackfn
                                                  )}
                                              </Form.Control>
                                          </Form.Group>


                                          <Form.Group controlId="formGridAddr01">
                                              <Form.Label>市町村<span className="requre">※</span></Form.Label>
                                              <Form.Control placeholder="(例) 東京都渋谷区恵比寿"
                                                            name="addr01"
                                                            onChange={this.props.handleInputChangeSignUp}
                                                            value={this.props.addr01}
                                              />
                                              {this.props.addr01_err_msg}
                                          </Form.Group>


                                          <Form.Group controlId="formGridAddr02">
                                              <Form.Label>丁目・番地<span className="requre">※</span></Form.Label>
                                              <Form.Control placeholder="(例) 四丁目20番3号"
                                                            name="addr02"
                                                            value={this.props.addr02}
                                                            onChange={this.props.handleInputChangeSignUp}
                                              />
                                              {this.props.addr02_err_msg}
                                          </Form.Group>


                                          <Form.Group controlId="formGridAddr03">
                                              <Form.Label>建物名・部屋番号</Form.Label>
                                              <Form.Control placeholder="(例) 恵比寿ガーデンプレイスタワー15階"
                                                            name="addr03"
                                                            value={this.props.addr03}
                                                            onChange={this.props.handleInputChangeSignUp}
                                              />
                                          </Form.Group>

                                          <Form.Group controlId="formGridPhnoe">
                                              <Form.Label>電話番号<span className="requre">※</span> 半角</Form.Label>
                                              <Form.Control placeholder="(例)03-5422-8506"
                                                  name="tel"
                                                  value={this.props.tel}
                                                  onBlur={this.props.handleOnBlur}
                                                  onChange={this.props.handleInputChangeSignUp}
                                              />
                                              {this.props.tel_err_msg}

                                              <div className="termsbox">
                                                <p className="center">本サービスをお客様がご利用する場合、以下の使用条件に同意されたものとみなします。</p>
                                                <p id="genelife%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"><strong>GeneLife利用規約</strong></p>
                                                <p>株式会社ジェネシスヘルスケア(以下「当社」といいます)は、当社の定める手続きを完了した利用者が、当社が提供する遺伝子検査の実施・販売・閲覧、その他関連サービス(以下「本サービス」といいます)のご利用にあたり、以下の通り「GeneLife利用規約」(以下「利用規約」といいます)を定めます。</p>
                                                <p id="%E7%AC%AC1%E6%9D%A1-%E9%81%A9%E7%94%A8%E7%AF%84%E5%9B%B2"><strong>第1条 適用範囲</strong></p>
                                                <p>利用規約は、本サービスの利用に関して、当社と利用者に適用されるものとします。</p>
                                                <p id="%E7%AC%AC2%E6%9D%A1-%E7%94%A8%E8%AA%9E%E5%AE%9A%E7%BE%A9"><strong>第2条 用語定義</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>「遺伝子検査キット」とは、遺伝子検査サービスを利用する際に、遺伝情報を採取するためのキットのことをいいます。</li>
                                                <li>「遺伝子検査サービス」とは、当社が定める所定の手続を経て、遺伝子検査キットで検体を弊社に送付し、遺伝学検査を行い、その結果を検査申込者に通知するサービスをいいます。</li>
                                                <li>「会員」とは、書類以外で遺伝子検査サービスの結果を閲覧するために、当社が定める所定の手続を経て会員登録を行った者をいいます。</li>
                                                <li>「会員希望者」とは、会員となることを希望する者をいいます。</li>
                                                <li>「検査希望者」とは、当社に対し当社が定める所定の手続を経て、遺伝子検査サービスを希望する者をいいます。</li>
                                                <li>「検査申込者」とは、検査希望者が遺伝子検査サービスを申し込みした者をいいます。</li>
                                                <li>「未検査会員」とは、会員規約に同意の上、当社が定める所定の手続を経て会員を行ったが、遺伝子検査サービスを完了していない者をいいます。</li>
                                                <li>「利用者」とは、「会員」及び「検査申込者」の何れかに属する者をいいます。</li>
                                                <li>「検体」とは、当社に対し当社が定める所定の手続を経て、遺伝子検査サービスを申し込みした際に送付される遺伝情報を採取するためのキットを使い、所定の方法で遺伝情報を採取したものをいいます。</li>
                                                <li>「会員ID情報」とは、GeneLifeのWebサイト及びアプリ等を利用する際に登録したユーザーID、パスワード、メールアドレス及びその他の利用するにあたって会員本人を特定するために必要な当社所定の情報をいいます。</li>
                                                <li>「検体識別情報」とは、遺伝子検査キットに記載されている、キットを識別する記号類を言います。</li>
                                                </ol>
                                                <p id="%E7%AC%AC3%E6%9D%A1-%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"><strong>第3条 利用規約について</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>利用規約において別段の定めの無い事項については、当社の「プライバシーポリシー」(以下「プライバシーポリシー」といいます)の規定と共に適用されます。ユーザーが本サービスを利用するには、利用規約に加えて又はプライバシーポリシーに同意する必要があります。</li>
                                                <li>また遺伝子検査キットの研究利用について定めた「遺伝子検査申込同意書」(以下「同意書」といいます)に同意した場合には、同意書にある規定も適用されます。</li>
                                                <li>利用規約と同意書又はプライバシーポリシーが異なる規定をした場合は、利用規約の規定が優先して適用されるものとします。</li>
                                                </ol>
                                                <p id="%E7%AC%AC4%E6%9D%A1-%E4%BC%9A%E5%93%A1%E8%B3%87%E6%A0%BC"><strong>第4条 会員資格</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>会員希望者は、利用規約に同意の上、第5条に当社が定める所定の手続きを行い会員登録するものとし、当社のシステムに会員情報が登録された時点で、当該会員希望者の会員登録が完了するものとします。ただし、会員情報の記載漏れがあった場合には、会員登録を完了することができないことがあります。</li>
                                                <li>利用規約に同意いただけない場合には、会員になることはできません。</li>
                                                <li>また暴力団員、暴力団準構成員、暴力団関係者、暴力団関係企業または総会屋等その他の反社会的勢力(以下「反社会的勢力」といいます。)の構成員(過去5年以内に構成員だった場合を含みます。)及びその関係者、または、サービスの悪用もしくは第三者に迷惑をかける行為を行う者等については、ご利用をお断りしています。</li>
                                                <li>会員希望者が、第9条に定める内容に該当することが判明した場合は、会員登録はできません。また、第9条に定める内容に該当することが判明した場合は、会員登録が完了したときであっても、当社は当該会員の資格を停止または取消すことができるものとします。</li>
                                                </ol>
                                                <p>本サービスは個人を対象としているため、法人は会員となることはできません。</p>
                                                <p id="%E7%AC%AC5%E6%9D%A1-%E4%BC%9A%E5%93%A1%E3%81%AE%E7%99%BB%E9%8C%B2"><strong>第5条 会員の登録</strong></p>
                                                <p>会員となることを希望する会員希望者は、Webサイト等にて、記載事項に同意の上、当社の定める方法で会員情報を入力していただき、登録手続きを行うものとし、当該手続きは、会員希望者に対し当社のシステムから登録手続完了画面を送信した時点で完了するものとします。</p>
                                                <p id="%E7%AC%AC6%E6%9D%A1-%E9%81%BA%E4%BC%9D%E5%AD%90%E6%A4%9C%E6%9F%BB%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%81%AE%E7%94%B3%E8%BE%BC%E3%83%BB%E5%AE%8C%E4%BA%86"><strong>第6条 遺伝子検査サービスの申込・完了</strong></p>
                                                <p>遺伝子検査サービスとなることを希望する会員希望者は、希望する遺伝子検査サービスのキットを購入した上で、キットに同梱されている研究同意書に記載し、当社の定める方法で会員情報を入力していただき、検体と共に所定の方法により送付することで行うものとし、当社から所定の方法での検査完了の通知を持って完了とします。</p>
                                                <p id="%E7%AC%AC7%E6%9D%A1-id%E3%83%BB%E8%AA%8D%E8%A8%BC%E6%83%85%E5%A0%B1%E3%81%AE%E7%AE%A1%E7%90%86"><strong>第7条 ID・認証情報の管理</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>利用者は、会員ID情報及び検体識別情報を責任を持って管理するものとします</li>
                                                <li>利用者は、会員ID情報及び検体識別情報を第三者に使用させたり、貸与・譲渡・名義変更・売買・質入等その他いかなる処分もしてはならないものとします。</li>
                                                <li>利用者は、会員ID情報及び検体識別情報が漏洩し、第三者に利用されていることを知った場合は、速やかに当社のコールセンターへ連絡するものとし、当社のコールセンターの指示に従うこととします。</li>
                                                </ol>
                                                <p id="%E7%AC%AC8%E6%9D%A1-%E9%80%80%E4%BC%9A"><strong>第8条 退会</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>利用者はいつでも退会できるものとし、退会に際しては、当社コールセンターに退会の申請をするものとします。</li>
                                                <li>特に記載の無い場合、退会時には今まで行った遺伝子検査による遺伝子検査サービスの結果は閲覧出来なくなります。</li>
                                                <li>会員でない検査申込者は遺伝子検査サービスの完了または進行中に結果の削除を希望することで退会することが出来ます。</li>
                                                <li>閲覧出来なくなった遺伝子検査サービスの結果の復元は行いません。</li>
                                                </ol>
                                                <p id="%E7%AC%AC9%E6%9D%A1-%E7%A6%81%E6%AD%A2%E4%BA%8B%E9%A0%85%E5%8F%8A%E3%81%B3%E4%BC%9A%E5%93%A1%E8%B3%87%E6%A0%BC%E3%81%AE%E5%81%9C%E6%AD%A2%E3%83%BB%E5%96%AA%E5%A4%B1"><strong>第9条 禁止事項及び会員資格の停止・喪失</strong></p>
                                                <p>当社は、利用者が以下の各号のいずれかに該当するとき、利用者の資格を停止し、または喪失させることができるものとします。また、当社は、利用者が以下の各号のいずれかに該当する疑義があるとき、当該疑義が解消されるまでの間、資格を停止することができるものとします。</p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>利用規約または当社が別に定める規約・特約等に違反した場合</li>
                                                <li>利用者が退会した場合</li>
                                                <li>利用者が反社会的勢力であることが判明した場合(過去5年以内に構成員だった場合を含みます。)</li>
                                                <li>利用者が実在しない場合(死亡した場合を含みます。)</li>
                                                <li>利用者が過去に利用規約違反等により、資格が停止され、または喪失されている場合</li>
                                                <li>会員登録手続及び遺伝子検査サービスの申込の際に当社に届け出た事項に虚偽・誤記または記入漏れがあった場合</li>
                                                <li>利用者が後見、保佐、補助開始の審判を受けており、成年後見人、保佐人、補助人の同意を得ていない場合</li>
                                                <li>不正利用、その他正常でない方法で利用された場合</li>
                                                <li>届け出た住所、電話番号または電子メールアドレス等の変更により、会員との連絡が取れなくなった場合</li>
                                                <li>その他、当社が利用者として不適格であると判断した場合</li>
                                                </ol>
                                                <p id="%E7%AC%AC10%E6%9D%A1-%E4%BC%9A%E5%93%A1%E3%81%AE%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E5%8F%8E%E9%9B%86%E3%83%BB%E5%88%A9%E7%94%A8%E3%83%BB%E6%8F%90%E4%BE%9B"><strong>第10条 会員の個人情報の収集・利用・提供</strong></p>
                                                <p>利用者は、第11条に示す会員の情報を、第12条に定める利用目的のため、当社が必要な保護措置を講じた上で収集、利用することに同意します。</p>
                                                <p id="%E7%AC%AC11%E6%9D%A1-%E5%8F%8E%E9%9B%86%E3%83%BB%E5%88%A9%E7%94%A8%E3%83%BB%E6%8F%90%E4%BE%9B%E3%81%99%E3%82%8B%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E9%A0%85%E7%9B%AE"><strong>第11条 収集・利用・提供する個人情報項目</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>氏名、住所、電話番号、生年月日、性別、メールアドレス等、利用者が申込時に届けた事項及びその後に届けた事項</li>
                                                <li>入会日、利用者の番号等、利用者と当社の契約に関する事項</li>
                                                <li>遺伝子検査サービスに提供された検体、及びその解析によって得られた情報</li>
                                                <li>利用者の当サービスの利用内容及び電話やメール等での問合せ等により当社が知り得た情報(通話内容を含む)</li>
                                                <li>官報や電話帳等一般に公開されている情報</li>
                                                <li>GeneLifeサイト及びアプリ等を利用・閲覧した場合の、閲覧したページ、広告の履歴、閲覧時間、閲覧方法、端末の利用環境、Cookie情報、IPアドレス、位置情報、端末の固体識別番号等の情報</li>
                                                </ol>
                                                <p id="%E7%AC%AC12%E6%9D%A1-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E5%88%A9%E7%94%A8%E7%9B%AE%E7%9A%84"><strong>第12条 個人情報の利用目的</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>新商品・サービスの案内のため</li>
                                                <li>商品・サービスの提供を含む契約の締結及び履行、契約後の管理並びに提供した商品・サービスのアフターサービスの実施のため</li>
                                                <li>商品・サービスの提供に必要な連絡のため(宅配業者等へ商品等の発送を依頼する場合を含みます。)</li>
                                                <li>商品・サービスに関する情報及びその他当社の事業活動に関する情報の案内のため</li>
                                                <li>新商品・新サービス及びこれらを提供するソフトウェア、システム、設備、機器等の検討及び開発のため</li>
                                                <li>商品・サービスに関する料金の請求収納及び債権保全のため(信販会社等へクレジットカード等による支払い手続きを依頼する場合を含みます。)</li>
                                                <li>市場調査その他の調査・研究のため</li>
                                                <li>経営分析のため</li>
                                                <li>懸賞・キャンペーン等の実施のため</li>
                                                <li>取引先との契約の締結及び履行並びに契約後の管理のため</li>
                                                <li>CSR(企業の社会的責任)に関する活動のため</li>
                                                <li>お客さまからのお問合せやご意見の受付及び回答のため</li>
                                                <li>お客さま及び従業員のセキュリティの確保のため</li>
                                                <li>セキュリティの確保にかかるソフトウェア、システム、設備、機器等の検討及び開発のため</li>
                                                <li>施設、設備及び機器の保守管理並びにその利用状況の管理のため</li>
                                                <li>利用者の承諾に基づく、当社サービス利用企業への個人情報の提供及びマッチングのため</li>
                                                <li>個人を特定できないよう加工した情報の当社および当社サービスを紹介するための参考資料としての取引先会社への提示のため</li>
                                                </ol>
                                                <p id="%E7%AC%AC13%E6%9D%A1-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E7%AC%AC%E4%B8%89%E8%80%85%E6%8F%90%E4%BE%9B"><strong>第13条 個人情報の第三者提供</strong></p>
                                                <p>当社は、次に掲げる場合を除き、お客様の個人情報をあらかじめ本人の同意を得ることなく、第三者に提供することはございません。</p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>法令に基づく場合</li>
                                                <li>人の生命、身体又は財産の保護のために必要がある場合であって、ご本人様の同意を得ることが困難な場合</li>
                                                <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人様の同意を得ることが困難な場合</li>
                                                <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人様の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合</li>
                                                </ol>
                                                <p id="%E7%AC%AC14%E6%9D%A1-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E6%A5%AD%E5%8B%99%E5%A7%94%E8%A8%97"><strong>第14条 個人情報の業務委託</strong></p>
                                                <p>当社は、個人情報取扱い業務の一部を外部に委託することがあります。 当該委託先に個人情報の開示を行う場合には、個人情報を適正管理などにより保護水準を確保している委託先を選定し、機密保持契約を結んだ上で開示します。</p>
                                                <p id="%E7%AC%AC15%E6%9D%A1-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E9%96%8B%E7%A4%BA%E7%AD%89%E3%81%AE%E8%AB%8B%E6%B1%82"><strong>第15条 個人情報の開示等の請求</strong></p>
                                                <p>利用者は、当社が保有する個人情報について、ご自身の個人情報の開示等を希望される場合、プライバシーポリシーに基づいて当社の「個人情報に関するお問合わせ窓口」に申し出ることができます。その際、当社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。</p>
                                                <p id="%E7%AC%AC16%E6%9D%A1-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AE%E5%8F%96%E6%89%B1%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E4%B8%8D%E5%90%8C%E6%84%8F"><strong>第16条 個人情報の取扱に関する不同意</strong></p>
                                                <p>当社は、利用者が入会の申し込みに必要な事項の記載を希望しない場合及び本同意条項の内容の全部または一部を承諾できない場合は、入会をお断りすることや退会の手続をとることがあります。</p>
                                                <p id="%E7%AC%AC17%E6%9D%A1-%E6%9C%AC%E8%A6%8F%E7%B4%84%E4%B8%8A%E3%81%AE%E5%9C%B0%E4%BD%8D%E3%81%AE%E8%AD%B2%E6%B8%A1%E7%AD%89"><strong>第17条 本規約上の地位の譲渡等</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>ユーザーは、当社の書面による事前の承諾なく、本規約上の地位又は本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることができません。</li>
                                                <li>当社は本サービスにかかる事業の全部又は一部を他社に譲渡した場合には、当該事業譲渡に伴い本規約上の地位、本規約に基づく当社の権利及び義務並びにユーザーのアカウントその他の情報等を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項にかかる事業譲渡は、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含みます。</li>
                                                </ol>
                                                <p id="%E7%AC%AC18%E6%9D%A1-%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%81%AE%E4%B8%AD%E6%96%AD%E5%8F%8A%E3%81%B3%E7%B5%82%E4%BA%86"><strong>第18条 サービスの中断及び終了</strong></p>
                                                <p>当社は、次の各号に該当する場合に、本サービスのサービスを中断または終了することができるものとします。</p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>本サービスの提供に必要な設備の保守・点検を行う場合、または障害が発生した場合</li>
                                                <li>当社が、本サービスの中断または終了を判断した場合</li>
                                                <li>その他、やむを得ない事情がある場合
                                                <ol style={{listStyleType:"lower-latin", marginLeft: "1em"}}>
                                                <li>当社は、本サービスの中断または終了に伴って利用者に生じた損害その他いかなる不利益について、一切の責任を負いません。</li>
                                                <li>当社は、本サービスを中断または終了するときには、事前に本サイトでの告知又は当社が適当と判断する方法により本サービスを終了する旨を通知するものとします。ただし、本サービスの中断または終了が緊急に必要となった場合、その他やむを得ない事情がある場合には、この限りではありません。</li>
                                                </ol>
                                                </li>
                                                </ol>
                                                <p id="%E7%AC%AC19%E6%9D%A1-%E5%85%8D%E8%B2%AC%E4%BA%8B%E9%A0%85%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"><strong>第19条 免責事項について</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>当社は、本サービスに起因して発生した利用者の損害については、それが当社の故意または重大な過失によるものであることが明白な場合を除き、一切の責任を負わないものとします。</li>
                                                <li>当社は、天災地変その他の不可抗力(当社の責に帰すべき事由によらない、ネットワーク障害、サーバー障害等を含みます)によって生じた損失につき、一切責任を負わないものとします。</li>
                                                <li>当社は、業務遂行上通常要求される程度の合理的な措置を当社が講じていたにもかかわらず、第三者の責に帰すべき事由により生じた損失につき、一切責任を負わないものとします。</li>
                                                <li>当社が、本サービスに関して利用者に対し損害賠償責任を負う場合、当社が賠償する損害は、通常かつ直接の損害に限るものとし、当社はいかなる場合であっても、間接損害、特別損害、付随的損害、派生的損害、逸失利益、使用機会の喪失による損害についての責任は負わないものとします。</li>
                                                </ol>
                                                <p id="%E7%AC%AC20%E6%9D%A1-%E6%BA%96%E6%8B%A0%E6%B3%95"><strong>第20条 準拠法</strong></p>
                                                <p>利用規約及び当サービスの利用に係る契約の成立、効力、履行及び解釈に関しては、日本法に準拠するものとします。</p>
                                                <p id="%E7%AC%AC21%E6%9D%A1-%E7%B4%9B%E4%BA%89%E8%A7%A3%E6%B1%BA"><strong>第21条 紛争解決</strong></p>
                                                <p>利用者と当社との間で発生した問題について解決しない場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
                                                <p id="%E7%AC%AC22%E6%9D%A1-%E6%96%BD%E8%A1%8C%E3%83%BB%E6%9C%89%E5%8A%B9%E9%96%8B%E5%A7%8B%E6%97%A5"><strong>第22条 施行・有効開始日</strong></p>
                                                <p>本利用規約は、日本標準時間2020年3月31日より有効とします。</p>
                                                <p id="%E7%AC%AC23%E6%9D%A1-%E8%A6%8F%E7%B4%84%E3%81%AE%E5%A4%89%E6%9B%B4%E7%AD%89"><strong>第23条 規約の変更等</strong></p>
                                                <ol style={{listStyleType:"decimal", marginLeft: "2em"}}>
                                                <li>当社は、法令に定める範囲内で、利用規約を変更できるものとします。当該変更は、あらかじめ事前に本サイトでの告知又は当社が適当と判断する方法により告知するものとします。なお、利用規約の変更について告知した後、以下のいずれかに該当する場合、利用者は、変更内容を承認したものとみなすものとします。
                                                <ol style={{listStyleType:"lower-latin", marginLeft: "1em"}}>
                                                <li>利用者が新たに検査申込みを行った場合</li>
                                                <li>利用者が変更の告知から60日以内に退会の申し出がなかった場合</li>
                                                </ol>
                                                </li>
                                                <li>利用規約の変更後は、変更後の内容のみ有効となります。</li>
                                                </ol>
                                                <p id="%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E8%8B%A6%E6%83%85%E3%83%BB%E7%9B%B8%E8%AB%87%E7%AA%93%E5%8F%A3"><strong>個人情報に関する苦情・相談窓口</strong></p>
                                                <p>個人情報の開示又は訂正その他の個人情報に関するお問合せにつきましては、下記窓口で受付けております。</p>
                                                <p>〒150-6026 東京都渋谷区恵比寿四丁目20番3号<br/>
                                                ジェネシスヘルスケア株式会社 個人情報保護管理者 コーポレートセンター長<br/>
                                                メールアドレス：info＠genesis-healthcare.jp<br/>
                                                TEL：03-5422-8506（受付時間 10:00～17:00）</p>
                                                <p id="%E7%AE%A1%E7%90%86%E8%80%85%E8%8B%A5%E3%81%97%E3%81%8F%E3%81%AF%E3%81%9D%E3%81%AE%E4%BB%A3%E7%90%86%E4%BA%BA%E3%81%AE%E6%B0%8F%E5%90%8D%E5%8F%88%E3%81%AF%E8%81%B7%E5%90%8D%E6%89%80%E5%B1%9E%E5%8F%8A%E3%81%B3%E9%80%A3%E7%B5%A1%E5%85%88">管理者(若しくはその代理人)の氏名又は職名、所属及び連絡先</p>
                                                <ul>
                                                <li>管理者名：個人情報保護管理者</li>
                                                <li>所属部署：ジェネシスヘルスケア株式会社 コーポレートセンター長</li>
                                                <li>連絡先：03-5422-8506</li>
                                                </ul>
                                                <p id="%E9%99%84%E5%89%87"><strong>附則</strong></p>
                                                <p>この規約の変更は、2020年03月31日から施行する。</p>

                                              </div>
                                          </Form.Group>
                                      </Form>
                                  </SectionBody>
                                  <SectionFooter theme={this.props.theme}>
                                      <SectionFooterPrimaryContent theme={this.props.theme}>
                                          <Button disabled={this.props.isSignUpDisable} onClick={this.props.signUp}
                                                  theme={this.props.theme}>
                                              {I18n.get("Create Account")}
                                          </Button>
                                      </SectionFooterPrimaryContent>
                                      <SectionFooterSecondaryContent theme={this.props.theme}>

                                      </SectionFooterSecondaryContent>
                                  </SectionFooter>
                              </FormSection>
                          </div>
                      </div>
                  </div>
              </BlockUi>

        </div>
        <Footer theme={this.props.theme}/>
        </div>
        );
    }
}

SignUpComponents.propTypes = {
    theme: PropTypes.any,
    email: PropTypes.string,
    handleInputChangeSignUp: PropTypes.func,
    email_err_msg: PropTypes.any,
    emailConfirm: PropTypes.string,
    email_confirm_err_msg: PropTypes.any,
    password: PropTypes.string,
    password_err_msg: PropTypes.any,
    passwordConfirm: PropTypes.string,
    password_confirm_err_msg: PropTypes.any,
    name01: PropTypes.string,
    name02: PropTypes.string,
    name01_err_msg: PropTypes.any,
    name02_err_msg: PropTypes.any,
    kana01: PropTypes.string,
    kana02: PropTypes.string,
    kana01_err_msg: PropTypes.any,
    kana02_err_msg: PropTypes.any,
    kana_err_msg: PropTypes.any,
    name03: PropTypes.string,
    name03_err_msg: PropTypes.any,
    birth: PropTypes.any,
    handleBirthChange: PropTypes.func,
    birth_err_msg: PropTypes.any,
    menChecked: PropTypes.bool,
    handleRadioClick: PropTypes.func,
    womenChecked: PropTypes.bool,
    mailmagaDemandChecked: PropTypes.bool,
    handleRadioMailMagaClick: PropTypes.func,
    bloodtype: PropTypes.string,
    bloodtype_err_msg: PropTypes.func,
    mailmagaUndemandChecked: PropTypes.bool,
    handleZipChange: PropTypes.func,
    zip: PropTypes.string,
    zip_err_msg: PropTypes.any,
    pref: PropTypes.string,
    callbackfn: PropTypes.func,
    addr01: PropTypes.string,
    addr01_err_msg: PropTypes.any,
    addr02: PropTypes.string,
    addr02_err_msg: PropTypes.any,
    addr03: PropTypes.string,
    tel: PropTypes.string,
    tel_err_msg: PropTypes.any,
    signUp: PropTypes.func,
    changeStateFunc: PropTypes.func,
    isSignUpDisable: PropTypes.bool,
    blocking: PropTypes.bool,
    keepInView: PropTypes.bool,
    action_type: PropTypes.string,
    mode: PropTypes.string,
    handleOnBlur: PropTypes.func,
};
